export default __webpack_public_path__ + "static/media/Datum_404.b792e3e7.png";